<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-form class="searchForm" ref="form" :model="form" label-width="90px" style="margin-top: 20px">
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="时间段选择">
              <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.timeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="loadData">搜索</el-button>
          </el-col>
        </el-form>
      </el-row>

      <el-row>
        <el-col :span="24">
          <table class="cwTable">
            <tr>
              <th>项目</th>
              <th>数值</th>
            </tr>
            <tr>
              <td>总付款数</td>
              <td>0</td>
            </tr>
            <tr>
              <td>总收款额</td>
              <td>0</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import financeApi from "@/api/finance"
export default {
  components: { PageHeader },
  data() {
    return {
      f_type: "1",
      headLinks: [{ path: "", title: "财务统计" }],
      form: {
        timeRange: "",
      },
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.tableData = []
      financeApi.getList(this.curPage, this.pageSize, this.form.timeRange, this.form.author, this.form.title, this.form.status, this.form.statusResult).then((res) => {
        this.tableData = res.rows
      })
    },
  },
}
</script>
